'<template>
   <div class="page_member_join_container">
      <div class="max_width">
         <div class="container_nav">
            当前位置：<router-link to="/">首页 - </router-link><a>杂志详情</a>
         </div>
         <div class="table_content" v-loading="loading">
            <div class="right_detail" v-if="pageData != null">
               <h5 class="detail_title">{{pageData.title}}</h5>
               <div class="detail_source">
                  <span v-if="pageData.source != null">来源：{{pageData.source}}</span>
                  <span v-if="pageData.author != null">作者：{{pageData.author}}</span>
                  <span> 时间：{{pageData.createTime.substring(0,10)}}</span>
               </div>
               <div class="detail_desc" v-html="pageData.content"></div>
               <div class="detail_fileList" v-if="pageData.artFileList.length > 0">
                  <h4>附件下载：</h4>
                  <ul>
                     <li v-for="item in pageData.artFileList">
                        <a :href="item.url" :title="item.name">{{item.name}}</a>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
         <div class="table_content">
            <h2 class="shenqing_title">订阅申请</h2>
            <zazhiDialog />
         </div>
      </div>
   </div>
</template>


<script>
   import zazhiDialog from '@/components/common/zazhi_dialog'
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   import {
      getCookie,
      delCookie,
      setCookie
   } from '@/assets/js/util'; // cookie操作
   export default {
      name: 'zhuanti_join_page',
      components: {
         zazhiDialog
      },
      data() {
         return {
            loading: false,
             code:'',
             pageData:null,
         };
      },
      mounted() {
         if (this.$route.params.code) {
            this.code = this.$route.params.code
         }
         this.init();
      },
      methods: {
         init() {
            var _this = this;
            _this.loading = true;
            _this.$api.artInfo({
               code: this.code,
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.pageData = res.data;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
      }
   }
</script>
<style lang="less">

</style>
